enum TextFilterTypes {
    Text = "Text",
    Number = "Number"
}

class TextFilters
{
    private filterType: TextFilterTypes;
    private filter: HTMLElement;
    private resultsContainer: HTMLElement;
    private sortClass: string;
    private captureClasses: Array<string>;
    private gridArray: (string | Element | any) | null | undefined;
    constructor(filter: HTMLElement, resultsContainer: HTMLElement, sortClass: string, filterType: TextFilterTypes)
    {
        this.filter = filter;
        this.resultsContainer = resultsContainer;
        this.sortClass = sortClass;
        this.filterType = filterType;
        this.buildGridArray();
        //captureClasses: Array<string>,
        //this.captureClasses = captureClasses;
    }

    public static bindTextFilter (textFilterId: string, resultsContainer: HTMLElement, sortClass: string, textFilterTypes: TextFilterTypes): TextFilters | null {
        let titleTextFilter = document.getElementById(textFilterId) as HTMLDivElement;
        if (titleTextFilter) {
            titleTextFilter.onclick= ((e: MouseEvent) => {
                e.preventDefault();
                if (resultsContainer) {
                    return new TextFilters(e.target as HTMLElement, resultsContainer as HTMLElement, sortClass, textFilterTypes);
                }
            });
        }
        return null;
    }

    private bgr(container: Element) {
        let arrayObject = {};
        let sortElement = container.querySelector(this.sortClass);
        if (sortElement) {
            arrayObject[this.sortClass] = container.querySelector(this.sortClass).textContent.trim()
        }
        return {
            container : container,
            ...arrayObject
        }
    }

    private sortText(array: Array<any>, status: string, activeFn?: CallableFunction, deactiveFn?: CallableFunction) {
        let self = this;
        let statusNumber = Number(status);
        if (statusNumber == 0) {
            if (activeFn) {
                activeFn();
            }
            return array.sort((a, b) => {
                return a[self.sortClass].localeCompare(b[self.sortClass]);
            });
        } else {
            if (deactiveFn) {
                deactiveFn();
            }
            return array.sort((a, b) => {
                return b[self.sortClass].localeCompare(a[self.sortClass]);
            });
        }
    }

    private sortNumber(array: Array<any>, status: string, activeFn?: CallableFunction, deactiveFn?: CallableFunction) {
        let self = this;
        let statusNumber = Number(status);
        if (statusNumber == 0) {
            if (activeFn) {
                activeFn();
            }
            return array.sort((a, b) => {
                let aNumber = a[self.sortClass].replace(/\D/g,'');
                let bNumber = b[self.sortClass].replace(/\D/g,'');
                if (aNumber < bNumber ) {
                    return 1;
                }
                if (aNumber > bNumber) {
                    return -1;
                }
                return 0;
            });
        } else {
            if (deactiveFn) {
                deactiveFn();
            }
            return array.sort((a, b) => {
                let aNumber = a[self.sortClass].replace(/\D/g,'');
                let bNumber = b[self.sortClass].replace(/\D/g,'');
                if (aNumber > bNumber ) {
                    return 1;
                }
                if (aNumber < bNumber) {
                    return -1;
                }
                return 0;
            });
        }
    }

    buildGridArray() {
        let self = this;
        let resultElements: HTMLCollection;
        if (this.resultsContainer) {
            resultElements = this.resultsContainer.children
        }

        // sort grid
        this.gridArray = Array.from(resultElements)
            .map ( container => this.bgr(container));

        // status from filter to check current state
        let status: string | null = this.filter.dataset.status;
        if (!status) {
            this.filter.dataset.status = "0"
        }

        // sort liveArray by the specified options
        let liveArray:Array<any> = [];
        if (this.filterType = TextFilterTypes.Text) {
            liveArray = self.sortText(this.gridArray, this.filter.dataset.status, () => 
            {
                self.filter.querySelector('ion-icon').setAttribute("name", "caret-down-outline");
                self.filter.dataset.status = "1";
            }, () => 
            {
                self.filter.querySelector('ion-icon').setAttribute("name", "caret-up-outline");
                self.filter.dataset.status = "0";
            });
        } else if (this.filterType = TextFilterTypes.Number) {
            liveArray = self.sortNumber(this.gridArray, this.filter.dataset.status, () => 
            {
                self.filter.querySelector('ion-icon').setAttribute("name", "caret-down-outline");
                self.filter.dataset.status = "1";
            }, () => 
            {
                self.filter.querySelector('ion-icon').setAttribute("name", "caret-up-outline");
                self.filter.dataset.status = "0";
            });
        }
        this.resultsContainer.innerHTML = "";
        liveArray.forEach((item) => {
            self.resultsContainer.appendChild(item.container);
        });
    }

    getGridArray() {
        return this.gridArray;
    }
}

export default TextFilters;
export {
    TextFilterTypes
};